import { render, staticRenderFns } from "./sider.vue?vue&type=template&id=0971e6bc&scoped=true&"
import script from "./sider.vue?vue&type=script&lang=js&"
export * from "./sider.vue?vue&type=script&lang=js&"
import style0 from "./sider.vue?vue&type=style&index=0&id=0971e6bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0971e6bc",
  null
  
)

export default component.exports